import React from 'react';
import util from 'utils/utils';
import { Trans } from 'react-i18next';
import FormattedComment from 'components/lib/FormattedComment';

export default function IdeaCommentedContent({ events, ownerIdea = { name: 'Undefined' } }) {
  const textSuffix = events[0]?.isFollower ? 'an idea you follow' : 'your idea';
  return (
    <Trans i18nKey="notifications.ideaCommented">
      <b>{{ name: util.getEventUsers(events) }}</b> commented on {{ suffix: textSuffix }} <b>{{ idea: ownerIdea.name }}</b>: <FormattedComment noLink>"{{ comment: events[0].comment }}"</FormattedComment>
    </Trans>
  );
}
